<template>
	<div :class="{ pageRoot: true }">
		<div v-if="error" class="error">{{error}}</div>
		<div v-else-if="loading" class="loading"><ScaleLoader /> Loading…</div>
		<div v-else-if="graphiteData">
			<h2>General Status</h2>
			<div class="graphContainer">
				<img v-for="(g, index) in graphiteData.SingleServerQueryStrings"
					 :key="index"
					 :src="getImgSrc(g)"
					 :alt="'Graph: ' + getGraphTitle(g)"
					 class="graph"
					 role="button"
					 tabindex="0"
					 title="Click to view full screen"
					 @click="openLightbox(graphiteData.SingleServerQueryStrings, index, null)"
					 @keydown.enter.space.prevent="openLightbox(graphiteData.SingleServerQueryStrings, index, null)" />
			</div>
			<h2>Individual Server Status</h2>
			<div class="graphColumnContainer">
				<div v-for="sn in graphiteData.ServerNames" :key="sn" class="graphColumn">
					<div class="serverName">{{sn}}</div>
					<img v-for="(g, index) in graphiteData.MultiServerQueryStrings"
						 :key="index"
						 :src="getImgSrc(g, sn)"
						 :alt="'Graph: ' + getGraphTitle(g, sn)"
						 class="graph"
						 role="button"
						 tabindex="0"
						 title="Click to view full screen"
						 @click="openLightbox(graphiteData.MultiServerQueryStrings, index, sn)"
						 @keydown.enter.space.prevent="openLightbox(graphiteData.MultiServerQueryStrings, index, sn)" />
				</div>
			</div>
			<h2>Database Status</h2>
			<div class="graphContainer">
				<img v-for="(g, index) in graphiteData.DatabaseQueryStrings"
					 :key="index"
					 :src="getImgSrc(g)"
					 :alt="'Graph: ' + getGraphTitle(g)"
					 class="graph"
					 role="button"
					 tabindex="0"
					 title="Click to view full screen"
					 @click="openLightbox(graphiteData.DatabaseQueryStrings, index, null)"
					 @keydown.enter.space.prevent="openLightbox(graphiteData.DatabaseQueryStrings, index, null)" />
			</div>
		</div>
		<div v-else>
			Graphite data loading failed for an unknown reason.
		</div>
	</div>
</template>

<script>
	import { GetGraphiteUserData } from 'appRoot/api/GraphiteUserData';
	import { BuildRenderSrc, GetQueryStringTitle } from 'appRoot/scripts/GraphiteRender';
	import { ModalDialog } from 'appRoot/scripts/ModalDialog';
	import GraphiteLightbox from 'appRoot/vues/common/controls/GraphiteLightbox.vue';

	// Graphs are displayed at this CSS size; the actual image is requested at this size multiplied by
	// the display's devicePixelRatio (see GraphiteRender.js) so it stays crisp on high-DPI screens.
	const GRAPH_WIDTH = 500;
	const GRAPH_HEIGHT = 250;

	export default {
		components: {},
		props:
		{
		},
		data()
		{
			return {
				error: null,
				loading: false,
				graphiteData: null,
				cacheBust: Date.now()
			};
		},
		created()
		{
			this.loadData();
		},
		computed:
		{
		},
		methods:
		{
			loadData()
			{
				this.loading = true;
				this.error = null;
				GetGraphiteUserData()
					.then(data =>
					{
						if (data.success)
							this.graphiteData = data.data;
						else
							this.error = data.error;
					})
					.catch(err =>
					{
						this.error = err;
					})
					.finally(() =>
					{
						this.loading = false;
					});
			},
			getImgSrc(graph, serverName)
			{
				return BuildRenderSrc(graph, {
					width: GRAPH_WIDTH,
					height: GRAPH_HEIGHT,
					serverName: serverName,
					cacheBust: this.cacheBust
				});
			},
			getGraphTitle(graph, serverName)
			{
				return GetQueryStringTitle(graph, serverName) || "untitled";
			},
			openLightbox(queryStrings, index, serverName)
			{
				ModalDialog(GraphiteLightbox, {
					items: queryStrings.map(qs => ({ queryString: qs, serverName: serverName })),
					startIndex: index
				});
			}
		},
		watch:
		{
		}
	}
</script>

<style scoped>
	.pageRoot
	{
		margin: 8px;
	}

	.loading
	{
		margin-top: 80px;
		text-align: center;
	}

	.error
	{
		color: #FF0000;
		font-weight: bold;
	}

	.graphContainer
	{
		/*max-width: 1100px;*/
	}

		.graphContainer .graph
		{
			margin: 10px;
		}

	.graphColumnContainer
	{
		/*max-width: 1100px;*/
		display: flex;
		flex-wrap: wrap;
		gap: 2px;
	}

	.graphColumn
	{
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 2px;
	}

	.serverName
	{
		font-weight: bold;
		font-size: 1.2em;
		margin-bottom: 1em;
	}

	.graph
	{
		width: 500px;
		height: 250px;
		cursor: pointer;
	}

		.graph:hover, .graph:focus
		{
			outline: 2px solid var(--primary-color, #1A6999);
		}
</style>
